import NoWidgetImage from 'public/assets/img/widgets_empty_state.svg';
import DecisionMakingImage from 'public/assets/img/decision_making.svg';
import CustomizeReportsImage from 'public/assets/img/customize_report.svg';
import DynamicChart from 'public/assets/img/dynamic_chart_widget.svg';
import {
  BreakCnt,
  DashboardEmptyStateCnt,
  EmptyStateDescription,
  EmptyStateTitle,
} from 'pages/Dashboards/EmptyState/dashboardEmptyState.style';
import CustomButton from 'components/Button/CustomButton';
import AddIcon from '@mui/icons-material/Add';
import { setDialog } from 'store/actions/dialogActions';
import DIALOGS from 'utils/dialogIds';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import WithDashboardPermission from 'pages/Dashboards/withDashboardPermission';
import { firstItemConfig } from 'pages/Dashboards/utils';
import {
  useDashboard,
  useUpdateDashboard,
} from 'pages/Dashboards/hooks/useDashboard';
import { IWidget } from 'pages/Dashboards/interfaces';
const DashboardEmptyState = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { dashboardId } = params;
  const { dashboardQuery } = useDashboard({
    id: dashboardId,
  });
  const { updateDashboardQuery } = useUpdateDashboard();

  const handleGridSettingsChange = (gridSettings) => {
    const obj = {
      order: gridSettings,
      id: dashboardId as string,
    };
    updateDashboardQuery.mutate(obj, {
      onSuccess: () => {
        dashboardQuery.refetch();
      },
    });
  };
  const handleAddWidget = () => {
    dispatch(
      setDialog({
        dialogId: DIALOGS.CREATE_WIDGET_SELECT_TYPE_DIALOG,
        open: true,
        data: {
          dashboardId,
          onSuccessCallback: (res: IWidget) => {
            const newItemConfig = firstItemConfig(res);
            const newGridLayout = {
              gridsLayouts: [newItemConfig],
            };
            handleGridSettingsChange(newGridLayout);
          },
        },
      }),
    );
  };
  return (
    <DashboardEmptyStateCnt>
      <div className={'widgetEmptyStateTile'}>
        <img
          className="widgetEmptyStateTileIcon"
          src={NoWidgetImage}
          alt="No Widget"
        />
        <EmptyStateTitle>Start building your dashboard</EmptyStateTitle>
        <EmptyStateDescription>
          Build your dashboard by adding chart widgets to the builder.
          <br /> Refine the charts using the filters.
        </EmptyStateDescription>
        <WithDashboardPermission>
          <CustomButton
            variant="contained"
            style={{ borderRadius: '6px', marginTop: 9 }}
            startIcon={<AddIcon />}
            onClick={handleAddWidget}
          >
            Add Chart
          </CustomButton>
        </WithDashboardPermission>
      </div>
      <BreakCnt>
        <div className={'breakLine'}></div>
        <div className={'breakText'}>
          Xenia Dynamic Dashboard Builder for Informed Decision-Making
        </div>
        <div className={'breakLine'}></div>
      </BreakCnt>
      <div className={'dashboardBuilderInfo'}>
        <div className={'widgetEmptyStateTile'}>
          <div className={'tileImageCnt'}>
            <img
              className="widgetEmptyStateTileIcon"
              src={DynamicChart}
              alt="No Widget"
            />
          </div>
          <EmptyStateTitle>Dynamic Chart Widgets</EmptyStateTitle>
          <EmptyStateDescription>
            Seamlessly craft insightful reports by choosing from a variety of
            chart types, including bar graphs, pie charts, line charts, and
            more.
          </EmptyStateDescription>
        </div>
        <div className={'widgetEmptyStateTile'}>
          <div className={'tileImageCnt'}>
            <img
              className="widgetEmptyStateTileIcon"
              src={CustomizeReportsImage}
              alt="No Widget"
            />
          </div>
          <EmptyStateTitle>Customize Reports with Filters</EmptyStateTitle>
          <EmptyStateDescription>
            Take control of your data narrative by incorporating powerful
            filters. Our Dashboard Builder allows you to refine your charts
            instantly, enabling a granular analysis of specific data sets.
          </EmptyStateDescription>
        </div>
        <div className={'widgetEmptyStateTile'}>
          <div className={'tileImageCnt'}>
            <img
              className="widgetEmptyStateTileIcon"
              src={DecisionMakingImage}
              alt="No Widget"
            />
          </div>
          <EmptyStateTitle>Streamlined Decision-Making</EmptyStateTitle>
          <EmptyStateDescription>
            Visualize trends, identify patterns, and make informed choices
            backed by comprehensive, tailor-made reports. Elevate your analytics
            game and transform raw data into actionable intelligence
            effortlessly.
          </EmptyStateDescription>
        </div>
      </div>
    </DashboardEmptyStateCnt>
  );
};

export default DashboardEmptyState;
